
export default function WhyBCSection() {
  const benefits = [
    {
      icon: "ri-shield-check-line",
      title: "Safety Impact",
      description: "Reduce workplace injuries by 85% through intelligent automation and comprehensive safety protocols."
    },
    {
      icon: "ri-line-chart-line",
      title: "Proven ROI",
      description: "Average 300% ROI within 18 months through increased productivity and reduced operational costs."
    },
    {
      icon: "ri-rocket-line",
      title: "Fast Deployment",
      description: "Leverage BrainCommerce's staffing network for rapid implementation and seamless workforce integration."
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Why BC Robotics</h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              We combine cutting-edge robotics technology with BrainCommerce's proven 
              staffing and outsourcing expertise to deliver unmatched deployment speed and reliability.
            </p>
            
            <div className="space-y-6">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-xl mr-4 flex-shrink-0">
                    <i className={`${benefit.icon} text-blue-600 text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">{benefit.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://static.readdy.ai/image/89ce65a415860e3da90921dded83bf21/8512788def30570a390dfed2d893985c.webp"
              alt="BC Robotics Humanoid Workforce"
              className="w-full rounded-2xl shadow-lg object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
